<app-company-info
  [companyInitials]="companyInitials"
  [company]="company"
></app-company-info>

<div class="branch-details">
  <button mat-button="" (click)="location.back()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div>
    <span class="mat-h2">{{ branchHeader }}</span>
  </div>
</div>

<mat-card>
  <mat-card-content>
    <div class="header-wrapper">
      <div class="header-wrapper-left-button">
        <span class="mat-h2">{{
          'BRANCH_USERS_TABLE.branchAdmins' | translate
        }}</span>
      </div>
      <div class="header-wrapper-right-button">
        <div
          class="closed-btn"
          [matTooltip]=" isEqual(branchInfo?.status, 'Inactive')?('COMPANY_BRANCHES.addBranchAdminToClosedBranches' | translate) :'COMPANY_BRANCHES.addBranchAdminToBranches' | translate"
        >
          <button
            mat-stroked-button
            color="primary"
            aria-label="plus"
            mat-button
            (click)="addBranchAdmins()"
            [disabled]="isEqual(this.branchInfo?.status, 'Inactive')"
          >
            <mat-icon>add</mat-icon>
            <span>{{ 'BRANCH_USERS_TABLE.addBranchAdmin' | translate }}</span>
          </button>
        </div>
        <div
          class="closed-btn"
          [matTooltip]="
            this.selection.hasValue()
              ? ('BRANCH_USERS_TABLE.removeBranchAdmin' | translate)
              : ('Remove_User_Disabled' | translate)
          "
        >
          <button
            mat-stroked-button
            color="primary"
            aria-label="trash"
            mat-button
            [disabled]="!this.selection.hasValue()"
            (click)="removeBranchAdmins()"
          >
            <mat-icon>remove</mat-icon>
            <span>{{
              'BRANCH_USERS_TABLE.removeBranchAdmin' | translate
            }}</span>
          </button>
        </div>
      </div>
    </div>
    @if (noRecordFound) {
    <app-not-found
      [displayMessage]="message"
    ></app-not-found>
    }

    <table
      mat-table
      [dataSource]="usersDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
      matSort
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            [disabled]="usersDataSource === undefined"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'COMPANY_USERS.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.name }}
          @if (user.isCompanyAdmin) {
          <mat-chip>{{
            'COMPANY_ADD_USERS.admin' | translate | uppercase
          }}</mat-chip>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPANY_USERS.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    @if (!noRecordFound) {
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
    }
  </mat-card-content>
</mat-card>


@if (isLoading) {
<app-spinner></app-spinner>
}
